import { render, staticRenderFns } from "./template-2.vue?vue&type=template&id=1322863c&scoped=true"
import script from "./template-2.vue?vue&type=script&lang=js"
export * from "./template-2.vue?vue&type=script&lang=js"
import style0 from "./template-2.vue?vue&type=style&index=0&id=1322863c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1322863c",
  null
  
)

export default component.exports